<template>
  <nav class="navbar-menu">
    <ul class="main-menu">
      <li v-for="(_, keyArea, indexArea) in areas" :key="indexArea">
        <a :class="{active: keyArea.toLowerCase() === routeParent}"
           href="javascript:;"
           v-on:click="goToArea(`/${keyArea}`)">
          <span style="cursor:pointer;">{{areas[keyArea].name}}</span>
          <i class="icon-arrow" v-if="showArrow(keyArea)"></i>
        </a>
        <ul class="sub-menu"
            v-bind:class="{activeSubmenu: keyArea.toLowerCase() === routeParent}"
            v-if="Object.keys(areas[keyArea]).length >= 2">
          <li v-for="(_, keyRoute, indexRoute) in filterAreas(keyArea)" :key="indexRoute">
            <a v-on:click="goToArea(`#/${keyArea}/${areas[keyArea][keyRoute].routeName}`)"
               :href="`#/${keyArea}/${areas[keyArea][keyRoute].routeName}`"
               :class="{active: keyRoute.toLowerCase() === routeName}">{{areas[keyArea][keyRoute].name}}</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>
<script>
import MiddlewareService from '@/MiddlewareService.js';
import { AREAS } from '@/helpers/Constants';
import switchLang from '@/helpers/switchLanguage';
import { changeLangBus, loginBus } from '@/helpers/Bus';

const R = require('ramda');

export default {
  name: "navbar",
  data: function() {
    return {
      switchLang,
      storLang: localStorage.langType,
      isActiveUsers: false,
      selectedRoute: "",
      selectedArea: ""
    };
  },
  mounted() {
    this.getAreas();
    this.goToArea(this.$router.history.current.path);
  },
  computed: {
    routeParent() {
      return this.$route && this.$route.matched[0] ? this.$route.matched[0].props.default.parent.toLowerCase() : {};
    },
    routeName() {
      return this.$route && this.$route.matched[0] ? this.$route.matched[0].props.default.menuName.toLowerCase() : {};
    },
    areas() {
      const newAreas = this.$store.state.areas;
      for (const area in newAreas) {
        if (area === "MediaLibrary") {
          if (newAreas[area].name) newAreas[area].name = this.switchLang[this.storLang].mainItems.mediaLibrary;
          if (newAreas[area].Document) newAreas[area].Document.name = this.switchLang[this.storLang].mainItems.documents;
          if (newAreas[area].Image) newAreas[area].Image.name = this.switchLang[this.storLang].mainItems.images;
          if (newAreas[area].Video) newAreas[area].Video.name = this.switchLang[this.storLang].mainItems.videos;
          if (newAreas[area].MediaCategories) newAreas[area].MediaCategories.name = this.switchLang[this.storLang].mediaLibrary.mediaCategories;
          if (newAreas[area].Font) newAreas[area].Font.name = this.switchLang[this.storLang].mainItems.fonts;
        }
        if (area === "Published") {
          if (newAreas[area].name) newAreas[area].name = this.switchLang[this.storLang].mainItems.dashboard;
          if (newAreas[area].Event) newAreas[area].Event.name = this.switchLang[this.storLang].mainItems.events;
          if (newAreas[area].Offer) newAreas[area].Offer.name = this.switchLang[this.storLang].mainItems.offers;
          if (newAreas[area].RestaurantAndCafe) newAreas[area].RestaurantAndCafe.name = this.switchLang[this.storLang].mainItems.restaurantsCafes;
          if (newAreas[area].Service) newAreas[area].Service.name = this.switchLang[this.storLang].mainItems.services;
          if (newAreas[area].Shop) newAreas[area].Shop.name = this.switchLang[this.storLang].mainItems.shops;
          if (newAreas[area].Slideshow) newAreas[area].Slideshow.name = this.switchLang[this.storLang].mainItems.infoSlideshow;
          if (newAreas[area].SurroundingArea) newAreas[area].SurroundingArea.name = this.switchLang[this.storLang].mainItems.surroundingArea;
          if (newAreas[area].ServiceCompany) newAreas[area].ServiceCompany.name = this.switchLang[this.storLang].mainItems.serviceCompany;
          if (newAreas[area].Shops) newAreas[area].Shops.name = this.switchLang[this.storLang].mainItems.shopsList;
          if (newAreas[area].Restaurants) newAreas[area].Restaurants.name = this.switchLang[this.storLang].mainItems.restaurants;
          if (newAreas[area].ServiceCompanies) newAreas[area].ServiceCompanies.name = this.switchLang[this.storLang].mainItems.servCompany;
          if (newAreas[area].Parking) newAreas[area].Parking.name = this.switchLang[this.storLang].mainItems.parking;
        }
        if (area === "User") {
          if (newAreas[area].name) newAreas[area].name = this.switchLang[this.storLang].mainItems.users;
          if (newAreas[area].User) newAreas[area].User.name = this.switchLang[this.storLang].mainItems.usersList;
          if (newAreas[area].UserGroup) newAreas[area].UserGroup.name = this.switchLang[this.storLang].mainItems.usersGroup;
        }
        if (area === "Statistics") {
          if (newAreas[area].name) newAreas[area].name = this.switchLang[this.storLang].mainItems.statistics;
          if (newAreas[area].Statistic) newAreas[area].Statistic.Statistic.name = this.switchLang[this.storLang].mainItems.statistics;
        }
        if (area === "Malls") {
          if (newAreas[area].name) newAreas[area].name = this.switchLang[this.storLang].mainItems.malls;
          if (newAreas[area].Mall) newAreas[area].Mall.name = this.switchLang[this.storLang].mainItems.malls;
        }
        if (area === "InfoPage") {
          if (newAreas[area].name) newAreas[area].name = this.switchLang[this.storLang].mainItems.Information;
          if (newAreas[area].Information) newAreas[area].Information.name = this.switchLang[this.storLang].mainItems.Information;
        }
      }
      return newAreas;
    },
  },
  methods: {
    showArrow(key) {
      return Object.keys(this.areas[key]).length > 2;
    },
    filterAreas(key) {
      const area = this.areas[key];
      const result = {};

      for (const key in area) {
        const val = area[key];
        if (val instanceof Object && val.constructor === Object) {
          result[key] = val;
        }
      }
      return result;
    },
    goToArea(url) {
      if (this.$router.history.current.path !== url) {
        switch (url) {
          case '/User':
            if (this.areas.User && this.areas.User.User) {
              this.selectedArea = "User";
              this.selectedRoute = "User";
              this.$router.push('/user/user');
            } else {
              this.selectedArea = "UserGroup";
              this.selectedRoute = "UserGroup";
              this.$router.push('/user/usergroup');
            }
            break;

          case '/Malls':
            this.selectedArea = "Mall";
            this.selectedRoute = "Mall";
            this.$router.push('/Malls/Mall');

            break;

          default:
            this.$router.push(url);
            break;
        }
      }

      const routeArr = url.split('/');
      const area = routeArr[1];
      this.selectedArea = area;

      if (url !== '/User' && url !== '/Malls') {
        this.selectedRoute = routeArr.length >= 3
          ? routeArr[2]
          : "";
      }
    },
    buildRoutes(claims) {
      let groupedCheckedAraes = {};

      R.forEach(c => {
        if (!c.claimValue) console.log('Something is going wrong in process of parsing claims, please reload the page ');
        try {
          const routesArr = c.claimValue.split('/');
          const routeName = routesArr[2];
          const header = routesArr[3];
          const item = AREAS[routeName];

          if (item && item.category && item[routeName]) {
            if (header === 'Get') {
              groupedCheckedAraes = {
                ...groupedCheckedAraes,
                [item.category]: {
                  ...groupedCheckedAraes[item.category],
                  name: item.category,
                  [routeName]: {
                    ...item,
                    [routeName]: {
                      read: true,
                      write: false,
                    }
                  }
                }
              };
            } else if (header === 'Post' || header === 'Put' || header === 'Delete') {
              groupedCheckedAraes = {
                ...groupedCheckedAraes,
                [item.category]: {
                  ...groupedCheckedAraes[item.category],
                  name: item.category,
                  [routeName]: {
                    ...item,
                    [routeName]: {
                      read: true,
                      write: true,
                    }
                  }
                }
              };
            }
          } else {
            if (item && item.category && groupedCheckedAraes[c.claimType] === undefined) groupedCheckedAraes[item.category] = { isActive: false };
            if (item && item.category) groupedCheckedAraes[item.category][routeName] = item;
          }
        } catch (exception) {
          console.log(exception);
        }
      }, claims);

      if (groupedCheckedAraes.MediaLibrary) {
        groupedCheckedAraes.MediaLibrary = {
          ...groupedCheckedAraes.MediaLibrary,
          Document: {
            name: "Documents",
            category: "MediaLibrary",
            routeName: 'Document',
            Document: groupedCheckedAraes.MediaLibrary.MediaLibrary.MediaLibrary
          },
          Image: {
            name: "Images",
            category: "MediaLibrary",
            routeName: 'Image',
            Image: groupedCheckedAraes.MediaLibrary.MediaLibrary.MediaLibrary
          },
          Video: {
            name: "Videos",
            category: "MediaLibrary",
            routeName: 'Video',
            Video: groupedCheckedAraes.MediaLibrary.MediaLibrary.MediaLibrary
          },
          MediaCategories: {
            name: 'Media Categories',
            category: 'MediaLibrary',
            routeName: 'Categories',
            MediaCategories: groupedCheckedAraes.MediaLibrary.MediaLibrary.MediaLibrary
          }
          /* Font: {
                        name: "Fonts",
                        category: "MediaLibrary",
                        routeName: 'Font',
                        Font: groupedCheckedAraes.MediaLibrary.MediaLibrary.MediaLibrary
                    } */
        };
        delete groupedCheckedAraes.MediaLibrary.MediaLibrary;
      }

      let newObject = {};
      newObject = {
        ...newObject,
        Published: groupedCheckedAraes.Published ? groupedCheckedAraes.Published : {},
        MediaLibrary: groupedCheckedAraes.MediaLibrary ? groupedCheckedAraes.MediaLibrary : {},
        User: groupedCheckedAraes.User ? groupedCheckedAraes.User : {},
        Statistics: groupedCheckedAraes.Statistics ? groupedCheckedAraes.Statistics : {},
        Malls: groupedCheckedAraes.Malls ? groupedCheckedAraes.Malls : {},
        InfoPage: groupedCheckedAraes.InfoPage ? groupedCheckedAraes.InfoPage : {}
      };

      if (!groupedCheckedAraes.Published) {
        delete newObject.Published;
      }

      if (!groupedCheckedAraes.MediaLibrary) {
        delete newObject.MediaLibrary;
      }

      if (!groupedCheckedAraes.User) {
        delete newObject.User;
      }

      if (!groupedCheckedAraes.Statistics) {
        delete newObject.Statistics;
      }

      if (!groupedCheckedAraes.Malls) {
        delete newObject.Malls;
      }

      if (!groupedCheckedAraes.InfoPage) {
        delete newObject.InfoPage;
      }

      return newObject;
    },
    async getAreas() {
      const mallId = localStorage.mallId;
      if (!mallId) return;
      const data = await MiddlewareService.processRequest('/Area');
      if (data && data.body && data.body.success) {
        const checkedAreas = this.buildRoutes(data.body.message);
        this.$store.commit('setAreas', checkedAreas);
      }
    }
  },
  created() {
    changeLangBus.$on('changeLang', () => {
      this.storLang = localStorage.langType;
    });
    loginBus.$on('updateAreas', () => {
      this.getAreas(true);
      this.selectedArea = "Published";
      this.selectedRoute = "Published";
    });
  }
};

</script>

<style>
  .activeSubmenu {
    display: block !important;
  }
</style>
